import Style from "../AddProject.style";
import { useTranslation } from "react-i18next";
import { Stack } from "@fluentui/react";
import FieldDatepicker from "../../../../components/FieldComponents/FieldDatepicker";
import { useState } from "react";
import { format } from "date-fns";

const CommencementDate = (props) => {
  const { commencementDate, control, setValue } = props;
  const { t } = useTranslation();
  const style = Style();
  const [selectedDate, setSelectedDate] = useState("");

  const onFormatDate = (date) => {
    return !date ? "" : format(new Date(date), "yyyy/MM/dd");
  };

  const onSelectDate = (e) => {
    setValue(
      "commencementDate",
      new Date(e),
      !commencementDate && { shouldValidate: true }
    );
    setSelectedDate(e);
  };

  return (
    <>
      <Stack className={style.client_field}>
        <FieldDatepicker
          label={t("project.commencement_date")}
          control={control}
          onSelectDate={onSelectDate}
          name="commencementDate"
          placeholderText={t("project.select_commencement_date")}
          defaultValue={
            selectedDate
              ? new Date(selectedDate)
              : commencementDate
              ? new Date(commencementDate)
              : ""
          }
          onFormatDate={onFormatDate}
          validationMessage={props?.errors?.commencementDate?.message}
          validation={props.register("commencementDate", {
            required: `${t("validation_message.commencementdate_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default CommencementDate;
